import * as R from 'ramda'

function validate (quantity) {
  if (quantity === undefined) { throw new Error(`invalid quantity ${quantity}`) }
  if (quantity === null) { throw new Error(`invalid quantity ${quantity}`) }
  if (quantity < 0) { throw new Error(`invalid quantity ${quantity}`) }
}

// function copyAndValidateSelectedPackages (selectedPackages) {
//   // const selectedPackages = { 1: 100, 2: 0 }
//   // const selectedPackages_normalized = { 1: 100 }
//   const selectedPackages_normalized = {}
//   Object.keys(selectedPackages).forEach((packageId) => {
//     const quantity = selectedPackages[packageId]

//     if (quantity === undefined) { throw new Error(`invalid quantity ${quantity}`) }
//     if (quantity === null) { throw new Error(`invalid quantity ${quantity}`) }
//     if (quantity < 0) { throw new Error(`invalid quantity ${quantity}`) }

//     // if (quantity > 0) {
//     selectedPackages_normalized[packageId] = quantity
//     // }
//   })
//   return selectedPackages_normalized
// }

function mergeSelectedPackagesAndPackages ({
  selectedPackages,
  packages,
}) {
  // selectedPackages = { 1: 100 }
  // packages = [{ id: 1, otherData: 'otherData1' }]
  // selectedPackages_ = [{ id: 1, conferencePackagesQuantity: 100, otherData: 'otherData1' }]
  const selectedPackages_ = Object.keys(selectedPackages)
    .map((packageId) => {
      const conferencePackagesQuantity = selectedPackages[packageId]
      const packageDetails = packages.find(
        (pkg) => pkg.id.toString() === packageId,
      )
      if (!packageDetails) {
        throw new Error(`package not found! ${packageId} ${packages}`)
      }
      return {
        conferencePackagesQuantity,
        ...packageDetails,
      }
    })
    .filter(Boolean)
  return selectedPackages_
}

export function calculatePackages ({ selectedPackages, packages }) {
  // const selectedPackages_normalized =
  //   copyAndValidateSelectedPackages(selectedPackages)

  R.forEach(validate, selectedPackages)

  const selectedPackages_ = mergeSelectedPackagesAndPackages({
    selectedPackages: R.filter(value => value > 0, selectedPackages),
    packages,
  })

  // same as
  // - how_much_paid = mtms.map { |data| data[:this_package_is_bought_times] * data[:conference_package].price }.sum
  const calculatedPriceCents = selectedPackages_
    .map(
      (x) =>
        // (x.is_live_ticket ? x.person_amount : 1) * // mistake
        x.price_cents *
        x.conferencePackagesQuantity,
    )
    .reduce((a, b) => a + b, 0)

  // same as
  // how_many_people_will_come_in_live_or_live_tickets = mtms.map { |data| data[:conference_package].is_live_ticket ? data[:this_package_is_bought_times] * data[:conference_package].person_amount : 0 }
  const inRealLifeTicketsBought = selectedPackages_
    .map((x) => x.is_live_ticket ? x.conferencePackagesQuantity * x.person_amount : 0)
    .reduce((a, b) => a + b, 0)

  const conferencePackagesQuantity = selectedPackages_.length

  console.log({
    // selectedPackages_normalized,
    selectedPackages_,
    calculatedPriceCents,
    inRealLifeTicketsBought,
    conferencePackagesQuantity,
  })

  return {
    calculatedPriceCents,
    inRealLifeTicketsBought,
    conferencePackagesQuantity,
  }
}

export function generateErrorMessage ({
  conferencePackagesQuantity,
  inRealLifeTicketsBought,
  dataFromServer,
}) {
  if (conferencePackagesQuantity <= 0) {
    return 'Please make a package selection.'
  }
  if (
    inRealLifeTicketsBought > dataFromServer.conference.live_tickets_available
  ) {
    return `There are only ${dataFromServer.conference.live_tickets_available} tickets remaining for this event. Please adjust your order to reflect current availability.`
  }
  return null
}
